
import { LoggerFactory } from '@mmit/logging'
import { Component, Vue } from 'vue-property-decorator';
import AppFooter from './components/AppFooter.vue';
import AppHeader from './components/AppHeader.vue';

@Component({ components: { AppFooter, AppHeader } })
export default class App extends Vue {
    private readonly logger = LoggerFactory.getLogger('vue-ts-starter.App');

    private showUpgradeUI = false
    
    // public async accept(): void {
    //     this.showUpgradeUI = false
    //     await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    // }

    // - LiveCycle-Hooks -----------------------------------------------------------------------

    // public created(): void {
    //     this.logger.info('Created!');
    //
    //     if (this.$workbox) {
    //         this.$workbox.addEventListener("waiting", () => {
    //             this.showUpgradeUI = true;
    //         });
    //     }
    // }
}

